import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdmissionPage } from './admission.page';

const routes: Routes = [
  {
    path: '',
    component: AdmissionPage,
  },
  {
    path: 'mod0201',
    loadChildren: () =>
      import('./mod0201/mod0201.module').then((m) => m.Mod0201PageModule),
  },
  {
    path: 'mod0202',
    loadChildren: () =>
      import('./mod0202/mod0202.module').then((m) => m.Mod0202PageModule),
  },
  {
    path: 'mod0210',
    loadChildren: () =>
      import('./mod0210/mod0210.module').then((m) => m.Mod0210PageModule),
  },
  {
    path: 'mod02013',
    loadChildren: () =>
      import('./mod02013/mod02013.module').then((m) => m.Mod02013PageModule),
  },
  {
    path: 'mod02014',
    loadChildren: () => import('./mod02014/mod02014.module').then( m => m.Mod02014PageModule)
  },
  {
    path: 'mod02015',
    loadChildren: () => import('./mod02015/mod02015.module').then( m => m.Mod02015PageModule)
  },
  {
    path: 'mod02017',
    loadChildren: () => import('./mod02017/mod02017.module').then( m => m.Mod02017PageModule)
  },
  {
    path: 'mod02020',
    loadChildren: () => import('./mod02020/mod02020.module').then( m => m.Mod02020PageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdmissionPageRoutingModule {}
